import React from 'react'
// hooks
import { useModalData } from 'hooks/index'
// components
import { CloseIcon, Modal } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// icons
import BusinessIcon from '@mui/icons-material/Business'
// types
import { ICompany } from 'types/graphql'
// views
import { CompaniesContainer, CompanyInfo, CompanyWrapper, Container, Description, Header } from './views'

const AuthCompanySelectModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, width, resolve, companies }
  } = useModalData({ modalType: Modals.AUTH_COMPANY_SELECT_MODAL })

  const onCompanySelect = (id: string) => () => {
    resolve(id)
    hideModal()
  }

  const onCancel = () => {
    resolve(null)
    hideModal()
  }

  if (!isOpen) {
    return null
  }

  return (
    <Modal hideModal={onCancel} isOpen={isOpen} width={width} PaperProps={{ style: { width: '554px' } }}>
      <Container>
        <Header>
          <span>Select Company</span>
          <CloseIcon onClick={onCancel} />
        </Header>
        <Description>You have access to {companies.length} companies</Description>
        <CompaniesContainer>
          {companies.map((item: ICompany) => (
            <CompanyWrapper key={item.id} onClick={onCompanySelect(item.id)}>
              <BusinessIcon />
              <CompanyInfo>
                <div>{item.name}</div>
                <div>{item.domainName}</div>
              </CompanyInfo>
            </CompanyWrapper>
          ))}
        </CompaniesContainer>
      </Container>
    </Modal>
  )
}

export default AuthCompanySelectModal
